import { useEffect } from "react";

// react-router components
import { Routes, Route, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// FBCE themes
import theme from "assets/theme";

// FBCE routes
import routes from "routes";
import Home from "pages/Home";
import SingleArticle from "pages/Blog/sections/single-article";
// import VisitorCardGoogle from "pages/ContactUs/VisitorCardGoogle";
import ErrorPage from "pages/404page";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/blog-posts/single-article/:postId" element={<SingleArticle />} />
        {getRoutes(routes)}
        <Route path="/" element={<Home />} />
        {/* <Route path="/visitor-card" element={<VisitorCardGoogle />} /> */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </ThemeProvider>
  );
}
